"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function onVideoLoad(event) {
  this.setState({
    hasFired: {}
  });
  this.props.onVideoLoad(event);
}

exports.default = onVideoLoad;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jw-player/dist/create-event-handlers/on-video-load.js
// module id = 874
// module chunks = 10 11